import { render, staticRenderFns } from "./situationDisplay.vue?vue&type=template&id=473beb18&scoped=true"
import script from "./situationDisplay.vue?vue&type=script&lang=js"
export * from "./situationDisplay.vue?vue&type=script&lang=js"
import style0 from "./situationDisplay.vue?vue&type=style&index=0&id=473beb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473beb18",
  null
  
)

export default component.exports